<template>
    <div v-if="merges.length" class="px-6 pt-6">
        <v-alert v-if="mergedInto" type="info" dense outlined class="caption">
            This user was merged into
            <router-link :to="`/user_details/${mergedInto.kept_user_id}`">{{ mergedInto.kept_email }}</router-link>
            on {{ formatDate(mergedInto.created_date) }}.
        </v-alert>

        <div class="sansation info--text subtitle-2 mb-2">Merge History</div>

        <v-card v-for="merge in merges" :key="merge.merge_id" outlined class="mb-3 pa-3 caption">
            <div>
                <strong>{{ formatDate(merge.created_date) }}</strong>
                <span v-if="merge.merged_by_name"> by {{ merge.merged_by_name }}</span>
            </div>
            <div>Kept: {{ merge.kept_email }}</div>
            <div>Merged: {{ (merge.merged_emails || []).join(', ') }}</div>

            <div v-if="merge.undone_date" class="grey--text mt-1">
                Undone {{ formatDate(merge.undone_date) }}<span v-if="merge.undone_by_name"> by {{ merge.undone_by_name }}</span>
            </div>
            <div v-else-if="merge.can_undo" class="mt-2 text-right">
                <v-btn x-small outlined color="accent" @click="confirmUndo(merge)">Undo Merge</v-btn>
            </div>
            <div v-else class="grey--text mt-1">A later merge involves these users. Undo that one first.</div>
        </v-card>

        <v-dialog v-model="undoDialog" width="480">
            <v-card v-if="undoMerge">
                <v-card-title class="info white--text">
                    <div class="headline">Undo Merge</div>
                </v-card-title>
                <v-card-text class="pt-4">
                    <p>
                        This restores {{ (undoMerge.merged_emails || []).join(', ') }} as separate users and moves their projects,
                        questionnaire answers, documents, listing matches and activity back to them.
                    </p>
                    <p v-if="undoMerge.summary && undoMerge.summary.buyer_profiles_deleted">
                        The deleted Buyer Platform profile and its answers will be restored too.
                    </p>
                    <p class="mb-0">
                        Anything added to {{ undoMerge.kept_email }} since the merge stays with {{ undoMerge.kept_email }}.
                    </p>
                    <v-alert v-if="error_message" type="error" dense outlined class="mt-4 mb-0">{{ error_message }}</v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="undoDialog = false">Cancel</v-btn>
                    <v-btn color="accent" :loading="undoing" @click="runUndo">Undo Merge</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import axios from "axios";
    import Cookie from 'js-cookie';
    import appUrls from '../helpers/environment';

    export default {
        name: 'MergeHistory',

        props: {
            userId: { type: String, default: '' }
        },

        data: () => ({
            merges: [],
            undoDialog: false,
            undoMerge: null,
            undoing: false,
            error_message: ''
        }),

        computed: {
            // ACTIVE MERGE THAT ELIMINATED THIS USER, IF ANY
            mergedInto () {
                return this.merges.find(merge => !merge.undone_date && merge.kept_user_id !== this.userId) || null
            }
        },

        watch: {
            userId: {
                immediate: true,
                handler () { this.getHistory() }
            }
        },

        methods: {
            getHistory: async function () {
                this.merges = []
                if ( !this.userId ) return
                try {
                    const history_rs = await axios.get(`${appUrls.api}/api/admin/merge_history/${this.userId}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })
                    if ( history_rs.data.outcome ) this.merges = history_rs.data.merges
                } catch ( error ) {
                    console.log(error)
                }
            },

            confirmUndo ( merge ) {
                this.undoMerge = merge
                this.error_message = ''
                this.undoDialog = true
            },

            runUndo: async function () {
                this.undoing = true
                this.error_message = ''
                try {
                    const undo_rs = await axios.post(`${appUrls.api}/api/admin/merge_users/undo/${this.undoMerge.merge_id}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })
                    if ( undo_rs.data.outcome ) {
                        this.undoDialog = false
                        await this.getHistory()
                        this.$emit('mergeUndone', undo_rs.data)
                    } else {
                        this.error_message = undo_rs.data.message
                    }
                } catch ( error ) {
                    console.log(error)
                    this.error_message = (error.response && error.response.data && error.response.data.message) || 'The undo failed and no changes were made.'
                }
                this.undoing = false
            },

            formatDate ( value ) {
                return value ? String(value).substr(0, 10) : ''
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/MergeHistory.vue